import { format } from 'date-fns'
import { getStatus } from '../../../../../../../hooks/status'
import { departmentService } from '../../../../../../../utils/constants/callService'
import { Constants } from '../../../../../../../utils/constants'
import { Status } from '../../../../../../../utils/enums'
import { useContextState } from '../../../../../../../hooks/theme'
import { useTranslation } from 'react-i18next'
import { useEffect, useRef, useState } from 'react'
import { Item } from '../../../../../../../utils/types/generals'
import { getArea } from '../../../../../../../utils/methods/geServiceWithItemsFormat'
import { FilterBody } from '../../../../../../../hooks/filter/typing'
import { returnQuery } from '../../../../../../../utils/methods/returnQuery'
import { getPreviousYears, monthYear } from '../../../../../../../utils/constants/date_month'

const useGetData = ({filterMain}:{filterMain: FilterBody}) => {
  const { colors } = useContextState()
  const { t } = useTranslation()
  const [loadingTable, setLoadingTable] = useState(false)
  const [items, setItems] = useState<Record<string, Item[]>>({})
  const refTime = useRef<NodeJS.Timeout | null>(null)
  const [totalPages, setTotalPages] = useState(0)
  const [table, setTable] = useState<
    {
      id?: number
      email?: string
      phone?: string
      name?: string
      createTime: {
        label: string
        value: number
        type: string
      }
      status: {
        value: Status
        color: string
        text: string
      }
      areaName: {
        label?: string,
        value?: string | number
      }
      // users: User[] | undefined
    }[]
  >([])


  const requestTable = async () => {
    setLoadingTable(true)

    const department = await departmentService.getAllDepartmentsWithFilter(returnQuery({ ...filterMain.query, filter: filterMain.query.filter?.replaceAll('+', '%2B') }))

    setTotalPages(department.totalPages)

    setTable(
      !department?.errors
        ? department?.items.map((item) => {
            let status: Status = item?.status?.id || 1

            return {
              id: item.id,
              email: item?.email,
              phone: item?.phone ?? '',
              name: item.name,
              createTime: {
                label: item.createTime ? format(new Date(item.createTime), Constants.dateFormatGeneral) : 'N/A',
                value: item.createTime ? new Date(item.createTime).getTime() : 0,
                type: 'date',
              },
              status: getStatus(status, colors, t),
              areaName: {
                label: item.area?.name ?? 'N/A',
                value: item.areaId
              },
              // users: item.users,
            }
          })
        : []
    )

    setLoadingTable(false)
  }

  const getAreasServices = async () => {
    const areas = await getArea()
    setItems((prev) => ({ ...prev, areas }))
  }

  useEffect(() => {
    if (refTime.current) { clearTimeout(refTime.current) }

    refTime.current = setTimeout(() => {
      requestTable()
    }, 300)
  }, [filterMain.query.all])

  useEffect(() => {
    getAreasServices()
    setItems((prev) => ({
      ...prev,
      createYear: getPreviousYears(),
      month: monthYear.map((e) => ({
        ...e,
        value: e.value + 1,
      })),
    }))
  }, [])

  return { table, items, loadingTable, requestTable, totalPages }
}

export { useGetData }
